import 'babel-polyfill';
import createFocusTrap from 'focus-trap/index.js';
import { PinClickEvent, PinHoverEvent, CardHoverEvent, CardClickEvent } from './Events.js';
import { OptimizedResizeInstance } from 'js/components/Util/OptimizedResize.js';
import { Maps } from 'js/components/Maps/index.js';
import { SearchMap } from 'js/search/modules/MapboxGL.js';

export class CobaltMap extends SearchMap {
  static initClass() {
    Maps.FactoryForProvider.MapboxGL = (data) => new this(data);
    this.instances = [];
    this.providerLoaded = false;
    this.className = "Yext.Maps.CobaltMap";
    this.breakPoint = 992;
  }

  constructor(args) {
    super(args);
    this.pinHeight = 48;
    this.pinWidth = 28;
  }

  calcOffset() {
    return 10;
  }

  normalPin(label, type) {
    switch(type) {
      case 'Mortgage Loan Officer':
        return `
        <svg width="28px" height="48px" viewBox="0 0 28 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: sketchtool 51.2 (57519) - http://www.bohemiancoding.com/sketch -->
          <title>E113490D-4520-4D7C-A66A-8B211AD6B1EF</title>
          <desc>Created with sketchtool.</desc>
          <defs></defs>
          <g id="Styles" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="StyleGuide" transform="translate(-525.000000, -3968.000000)">
                  <g id="MapPins" transform="translate(525.000000, 3968.000000)">
                      <g id="Elements/Buttons/Pins/Locator/Normal">
                          <path d="M14,48 C14.6704102,48 15.007487,47.6666667 15,47 C15.5,29 28,24 28,14 C28,6 22,0 14,0 C6,0 0,6 0,14 C0,24 12.5,29 13,47 C13,47.6607478 13.3295899,48 14,48 Z" id="Background" fill="#FFFFFF" fill-rule="nonzero"></path>
                          <path d="M14,47 C14.1182685,47 14.0012475,47.1166934 14.0003856,46.9722329 C14.2153763,39.2325657 16.340345,33.7288708 20.6597857,27.2380737 C20.9908023,26.7406571 21.3281896,26.2441139 21.7751224,25.59389 C21.9061769,25.4032244 22.0495325,25.1951135 22.3200642,24.8024632 C22.5389003,24.4846779 22.6972714,24.2540397 22.8515018,24.0281982 C23.687882,22.8034762 24.2622216,21.9193019 24.7691711,21.0555528 C26.2807856,18.4800385 27,16.3321083 27,14 C27,6.55228475 21.4477153,1 14,1 C6.55228475,1 1,6.55228475 1,14 C1,16.3321083 1.71921437,18.4800385 3.23082894,21.0555528 C3.73777845,21.9193019 4.31211801,22.8034762 5.14849817,24.0281982 C5.30272855,24.2540397 5.46109974,24.4846779 5.67993581,24.8024632 C5.95046747,25.1951135 6.09382314,25.4032244 6.22487755,25.59389 C6.67181044,26.2441139 7.00919774,26.7406571 7.34021434,27.2380737 C11.659655,33.7288708 13.7846237,39.2325657 14,47 C14,47.113711 13.8871094,47 14,47 Z" id="Border" stroke="#3949ab" stroke-width="2" fill-rule="nonzero"></path>
                          <text id="PinText" font-family="Roboto-Bold, Roboto" font-size="14" font-weight="bold" line-spacing="16" fill="#292929">
                              <tspan x='${this.pinWidth/2}'
                                    y='${this.pinHeight/2 - 4}'
                                    text-anchor='middle'>
                                ${label}
                              </tspan>
                          </text>
                      </g>
                  </g>
              </g>
          </g>
        </svg>
        `;
      case 'Wealth Manager':
        return `
        <svg width="28px" height="48px" viewBox="0 0 28 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: sketchtool 51.2 (57519) - http://www.bohemiancoding.com/sketch -->
          <title>E113490D-4520-4D7C-A66A-8B211AD6B1EF</title>
          <desc>Created with sketchtool.</desc>
          <defs></defs>
          <g id="Styles" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="StyleGuide" transform="translate(-525.000000, -3968.000000)">
                  <g id="MapPins" transform="translate(525.000000, 3968.000000)">
                      <g id="Elements/Buttons/Pins/Locator/Normal">
                          <path d="M14,48 C14.6704102,48 15.007487,47.6666667 15,47 C15.5,29 28,24 28,14 C28,6 22,0 14,0 C6,0 0,6 0,14 C0,24 12.5,29 13,47 C13,47.6607478 13.3295899,48 14,48 Z" id="Background" fill="#FFFFFF" fill-rule="nonzero"></path>
                          <path d="M14,47 C14.1182685,47 14.0012475,47.1166934 14.0003856,46.9722329 C14.2153763,39.2325657 16.340345,33.7288708 20.6597857,27.2380737 C20.9908023,26.7406571 21.3281896,26.2441139 21.7751224,25.59389 C21.9061769,25.4032244 22.0495325,25.1951135 22.3200642,24.8024632 C22.5389003,24.4846779 22.6972714,24.2540397 22.8515018,24.0281982 C23.687882,22.8034762 24.2622216,21.9193019 24.7691711,21.0555528 C26.2807856,18.4800385 27,16.3321083 27,14 C27,6.55228475 21.4477153,1 14,1 C6.55228475,1 1,6.55228475 1,14 C1,16.3321083 1.71921437,18.4800385 3.23082894,21.0555528 C3.73777845,21.9193019 4.31211801,22.8034762 5.14849817,24.0281982 C5.30272855,24.2540397 5.46109974,24.4846779 5.67993581,24.8024632 C5.95046747,25.1951135 6.09382314,25.4032244 6.22487755,25.59389 C6.67181044,26.2441139 7.00919774,26.7406571 7.34021434,27.2380737 C11.659655,33.7288708 13.7846237,39.2325657 14,47 C14,47.113711 13.8871094,47 14,47 Z" id="Border" stroke="#000" stroke-width="2" fill-rule="nonzero"></path>
                          <text id="PinText" font-family="Roboto-Bold, Roboto" font-size="14" font-weight="bold" line-spacing="16" fill="#292929">
                              <tspan x='${this.pinWidth/2}'
                                    y='${this.pinHeight/2 - 4}'
                                    text-anchor='middle'>
                                ${label}
                              </tspan>
                          </text>
                      </g>
                  </g>
              </g>
          </g>
        </svg>
        `;
      default:
        // Includes 'Branch'
        return `
        <svg width="28px" height="48px" viewBox="0 0 28 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: sketchtool 51.2 (57519) - http://www.bohemiancoding.com/sketch -->
          <title>E113490D-4520-4D7C-A66A-8B211AD6B1EF</title>
          <desc>Created with sketchtool.</desc>
          <defs></defs>
          <g id="Styles" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="StyleGuide" transform="translate(-525.000000, -3968.000000)">
                  <g id="MapPins" transform="translate(525.000000, 3968.000000)">
                      <g id="Elements/Buttons/Pins/Locator/Normal">
                          <path d="M14,48 C14.6704102,48 15.007487,47.6666667 15,47 C15.5,29 28,24 28,14 C28,6 22,0 14,0 C6,0 0,6 0,14 C0,24 12.5,29 13,47 C13,47.6607478 13.3295899,48 14,48 Z" id="Background" fill="#FFFFFF" fill-rule="nonzero"></path>
                          <path d="M14,47 C14.1182685,47 14.0012475,47.1166934 14.0003856,46.9722329 C14.2153763,39.2325657 16.340345,33.7288708 20.6597857,27.2380737 C20.9908023,26.7406571 21.3281896,26.2441139 21.7751224,25.59389 C21.9061769,25.4032244 22.0495325,25.1951135 22.3200642,24.8024632 C22.5389003,24.4846779 22.6972714,24.2540397 22.8515018,24.0281982 C23.687882,22.8034762 24.2622216,21.9193019 24.7691711,21.0555528 C26.2807856,18.4800385 27,16.3321083 27,14 C27,6.55228475 21.4477153,1 14,1 C6.55228475,1 1,6.55228475 1,14 C1,16.3321083 1.71921437,18.4800385 3.23082894,21.0555528 C3.73777845,21.9193019 4.31211801,22.8034762 5.14849817,24.0281982 C5.30272855,24.2540397 5.46109974,24.4846779 5.67993581,24.8024632 C5.95046747,25.1951135 6.09382314,25.4032244 6.22487755,25.59389 C6.67181044,26.2441139 7.00919774,26.7406571 7.34021434,27.2380737 C11.659655,33.7288708 13.7846237,39.2325657 14,47 C14,47.113711 13.8871094,47 14,47 Z" id="Border" stroke="#ED6E00" stroke-width="2" fill-rule="nonzero"></path>
                          <text id="PinText" font-family="Roboto-Bold, Roboto" font-size="14" font-weight="bold" line-spacing="16" fill="#292929">
                              <tspan x='${this.pinWidth/2}'
                                    y='${this.pinHeight/2 - 4}'
                                    text-anchor='middle'>
                                ${label}
                              </tspan>
                          </text>
                      </g>
                  </g>
              </g>
          </g>
        </svg>
        `;
    }
  }

  hoverPin(label, type) {
    switch(type) {
      case 'Mortgage Loan Officer':
        return `
        <svg width="28px" height="48px" viewBox="0 0 28 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: sketchtool 51.2 (57519) - http://www.bohemiancoding.com/sketch -->
          <title>E113490D-4520-4D7C-A66A-8B211AD6B1EF</title>
          <desc>Created with sketchtool.</desc>
          <defs></defs>
          <g id="Styles" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="StyleGuide" transform="translate(-525.000000, -3968.000000)">
                  <g id="MapPins" transform="translate(525.000000, 3968.000000)">
                      <g id="Elements/Buttons/Pins/Locator/Normal">
                          <path d="M14,48 C14.6704102,48 15.007487,47.6666667 15,47 C15.5,29 28,24 28,14 C28,6 22,0 14,0 C6,0 0,6 0,14 C0,24 12.5,29 13,47 C13,47.6607478 13.3295899,48 14,48 Z" id="Background" fill="#3949ab" fill-rule="nonzero"></path>
                          <path d="M14,47 C14.1182685,47 14.0012475,47.1166934 14.0003856,46.9722329 C14.2153763,39.2325657 16.340345,33.7288708 20.6597857,27.2380737 C20.9908023,26.7406571 21.3281896,26.2441139 21.7751224,25.59389 C21.9061769,25.4032244 22.0495325,25.1951135 22.3200642,24.8024632 C22.5389003,24.4846779 22.6972714,24.2540397 22.8515018,24.0281982 C23.687882,22.8034762 24.2622216,21.9193019 24.7691711,21.0555528 C26.2807856,18.4800385 27,16.3321083 27,14 C27,6.55228475 21.4477153,1 14,1 C6.55228475,1 1,6.55228475 1,14 C1,16.3321083 1.71921437,18.4800385 3.23082894,21.0555528 C3.73777845,21.9193019 4.31211801,22.8034762 5.14849817,24.0281982 C5.30272855,24.2540397 5.46109974,24.4846779 5.67993581,24.8024632 C5.95046747,25.1951135 6.09382314,25.4032244 6.22487755,25.59389 C6.67181044,26.2441139 7.00919774,26.7406571 7.34021434,27.2380737 C11.659655,33.7288708 13.7846237,39.2325657 14,47 C14,47.113711 13.8871094,47 14,47 Z" id="Border" stroke="#3949ab" stroke-width="2" fill-rule="nonzero"></path>
                          <text id="PinText" font-family="Roboto-Bold, Roboto" font-size="14" font-weight="bold" line-spacing="16" fill="#FFFFFF">
                              <tspan x='${this.pinWidth/2}'
                                    y='${this.pinHeight/2 - 4}'
                                    text-anchor='middle'>
                                ${label}
                              </tspan>
                          </text>
                      </g>
                  </g>
              </g>
          </g>
        </svg>
        `;
      case 'Wealth Manager':
        return `
        <svg width="28px" height="48px" viewBox="0 0 28 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: sketchtool 51.2 (57519) - http://www.bohemiancoding.com/sketch -->
          <title>E113490D-4520-4D7C-A66A-8B211AD6B1EF</title>
          <desc>Created with sketchtool.</desc>
          <defs></defs>
          <g id="Styles" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="StyleGuide" transform="translate(-525.000000, -3968.000000)">
                  <g id="MapPins" transform="translate(525.000000, 3968.000000)">
                      <g id="Elements/Buttons/Pins/Locator/Normal">
                          <path d="M14,48 C14.6704102,48 15.007487,47.6666667 15,47 C15.5,29 28,24 28,14 C28,6 22,0 14,0 C6,0 0,6 0,14 C0,24 12.5,29 13,47 C13,47.6607478 13.3295899,48 14,48 Z" id="Background" fill="#000" fill-rule="nonzero"></path>
                          <path d="M14,47 C14.1182685,47 14.0012475,47.1166934 14.0003856,46.9722329 C14.2153763,39.2325657 16.340345,33.7288708 20.6597857,27.2380737 C20.9908023,26.7406571 21.3281896,26.2441139 21.7751224,25.59389 C21.9061769,25.4032244 22.0495325,25.1951135 22.3200642,24.8024632 C22.5389003,24.4846779 22.6972714,24.2540397 22.8515018,24.0281982 C23.687882,22.8034762 24.2622216,21.9193019 24.7691711,21.0555528 C26.2807856,18.4800385 27,16.3321083 27,14 C27,6.55228475 21.4477153,1 14,1 C6.55228475,1 1,6.55228475 1,14 C1,16.3321083 1.71921437,18.4800385 3.23082894,21.0555528 C3.73777845,21.9193019 4.31211801,22.8034762 5.14849817,24.0281982 C5.30272855,24.2540397 5.46109974,24.4846779 5.67993581,24.8024632 C5.95046747,25.1951135 6.09382314,25.4032244 6.22487755,25.59389 C6.67181044,26.2441139 7.00919774,26.7406571 7.34021434,27.2380737 C11.659655,33.7288708 13.7846237,39.2325657 14,47 C14,47.113711 13.8871094,47 14,47 Z" id="Border" stroke="#000" stroke-width="2" fill-rule="nonzero"></path>
                          <text id="PinText" font-family="Roboto-Bold, Roboto" font-size="14" font-weight="bold" line-spacing="16" fill="#FFFFFF">
                              <tspan x='${this.pinWidth/2}'
                                    y='${this.pinHeight/2 - 4}'
                                    text-anchor='middle'>
                                ${label}
                              </tspan>
                          </text>
                      </g>
                  </g>
              </g>
          </g>
        </svg>
        `;
      default:
        // Includes 'Branch'
        return `
        <svg width="28px" height="48px" viewBox="0 0 28 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: sketchtool 51.2 (57519) - http://www.bohemiancoding.com/sketch -->
          <title>E113490D-4520-4D7C-A66A-8B211AD6B1EF</title>
          <desc>Created with sketchtool.</desc>
          <defs></defs>
          <g id="Styles" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="StyleGuide" transform="translate(-525.000000, -3968.000000)">
                  <g id="MapPins" transform="translate(525.000000, 3968.000000)">
                      <g id="Elements/Buttons/Pins/Locator/Normal">
                          <path d="M14,48 C14.6704102,48 15.007487,47.6666667 15,47 C15.5,29 28,24 28,14 C28,6 22,0 14,0 C6,0 0,6 0,14 C0,24 12.5,29 13,47 C13,47.6607478 13.3295899,48 14,48 Z" id="Background" fill="#ED6E00" fill-rule="nonzero"></path>
                          <path d="M14,47 C14.1182685,47 14.0012475,47.1166934 14.0003856,46.9722329 C14.2153763,39.2325657 16.340345,33.7288708 20.6597857,27.2380737 C20.9908023,26.7406571 21.3281896,26.2441139 21.7751224,25.59389 C21.9061769,25.4032244 22.0495325,25.1951135 22.3200642,24.8024632 C22.5389003,24.4846779 22.6972714,24.2540397 22.8515018,24.0281982 C23.687882,22.8034762 24.2622216,21.9193019 24.7691711,21.0555528 C26.2807856,18.4800385 27,16.3321083 27,14 C27,6.55228475 21.4477153,1 14,1 C6.55228475,1 1,6.55228475 1,14 C1,16.3321083 1.71921437,18.4800385 3.23082894,21.0555528 C3.73777845,21.9193019 4.31211801,22.8034762 5.14849817,24.0281982 C5.30272855,24.2540397 5.46109974,24.4846779 5.67993581,24.8024632 C5.95046747,25.1951135 6.09382314,25.4032244 6.22487755,25.59389 C6.67181044,26.2441139 7.00919774,26.7406571 7.34021434,27.2380737 C11.659655,33.7288708 13.7846237,39.2325657 14,47 C14,47.113711 13.8871094,47 14,47 Z" id="Border" stroke="#ED6E00" stroke-width="2" fill-rule="nonzero"></path>
                          <text id="PinText" font-family="Roboto-Bold, Roboto" font-size="14" font-weight="bold" line-spacing="16" fill="#292929">
                              <tspan x='${this.pinWidth/2}'
                                    y='${this.pinHeight/2 - 4}'
                                    text-anchor='middle'>
                                ${label}
                              </tspan>
                          </text>
                      </g>
                  </g>
              </g>
          </g>
        </svg>
        `;
    }
  }

  svgPin(label, type, state) {

    switch(state) {
      case 'hover':
        return this.hoverPin(label, type);
      case 'select':
        return this.normalPin(label, type);
      default:
        return this.normalPin(label, type);
    }
  }

  iconImage(loc, i, backgroundColor, textColor) {
    return `data:image/svg+xml;charset=utf8,${encodeURIComponent(this.svgPin(i+1, backgroundColor, textColor))}`;
  }

  registerResultHandlers() {
    registerResultHandlers();
  }

  removePins() {
    for (let pin of this.pins) {
      pin.remove();
    }
    this.pins = [];
  }

  updateMap(options = {}) {
    let boundsOptions = Object.assign({}, this.boundsOptions);

    const map = this.map;
    let marker;
    this.bounds = new mapboxgl.LngLatBounds();
    let idx = 0;

    let results = document.getElementsByClassName('ResultList-item');
    for (let location of Array.from(this.allLocations)) {
      let coord = new mapboxgl.LngLat(location.longitude, location.latitude);
      marker = this.preparePin(idx, location, map, coord);

      this.pins.push(marker);

      switch(location.customByName['Page Type']) {
        case 'Mortgage Loan Officer':
          results[idx].classList.add('ResultList-item--mortgage');
          break;
        case 'Wealth Manager':
          results[idx].classList.add('ResultList-item--wealth');
          break;
        default:
          results[idx].classList.add('ResultList-item--branch');
          break;
      }

      this.bounds.extend(coord);
      idx++;
    }
    if (options.keepCenterVisible) {
      this.bounds.extend(map.getCenter());
      boundsOptions.animate = true;
      boundsOptions.linear = false;
      boundsOptions.duration = 300;
    }

    if (this.allLocations.length > 0) {
      this.options.center = this.bounds.getCenter();
    } else {
      this.options.center = new mapboxgl.LngLat(this.longitude, this.latitude);
      this.options.zoom = 3;
    }

    if (this.pins.length > 0) {
      for (marker of Array.from(this.pins)) {
        marker.addTo(map);
      }
      map.fitBounds(this.bounds, boundsOptions);
    }
  }

  prepareMap() {
    const map = super.prepareMap();
    this.constructor.map = map;
    return map;
  }

  preparePin(i, loc, map, latLng) {
    let wrapper = document.createElement('div');
    let button = document.createElement('button');
    button.className = 'custom-icon-button';
    let icon = $(this.svgPin(i+1, loc.customByName['Page Type']));
    let image = icon[0];

    let normalPin = $(this.svgPin(i+1, loc.customByName['Page Type']))[0];
    let hoverPin = $(this.svgPin(i+1, loc.customByName['Page Type'], 'hover'))[0];

    button.setAttribute('data-lon', loc.longitude);
    button.setAttribute('data-lat', loc.latitude);

    button.addEventListener('mouseover', () => {
      button.classList.add('is-hovered');
      document.dispatchEvent(new PinHoverEvent(`js-yl-${loc.id}`, true));
    });
    button.addEventListener('mouseout', () => {
      button.classList.remove('is-hovered');
      document.dispatchEvent(new PinHoverEvent(`js-yl-${loc.id}`, false));
    })

    button.addEventListener('click', function() {
      document.dispatchEvent(new PinClickEvent(`js-yl-${loc.id}`));
    });

    button.appendChild(image);
    wrapper.appendChild(button);
    wrapper.className = 'custom-icon js-custom-icon';

    wrapper.isHovered = false;
    wrapper.isSelected = false;

    document.addEventListener(PinClickEvent.eventTypeName, event => {
      let myTarget = `js-yl-${loc.id}`;
      button.innerHTML = '';
      button.appendChild(normalPin);
      if (event.detail.yextId == myTarget) {
        button.classList.add('is-selected');
        wrapper.isSelected = true;
      } else {
        button.classList.remove('is-selected');
        button.classList.remove('is-hovered');
        wrapper.isSelected = false;
        wrapper.isHovered = false;
      }
    });

    document.addEventListener(CardHoverEvent.eventTypeName, event => {
      let myTarget = `js-yl-${loc.id}`;
      if (event.detail.yextId == myTarget && event.detail.active && !wrapper.isSelected) {
        button.classList.add('is-hovered');
        wrapper.isHovered = true;
        wrapper.style.zIndex = "1";
        button.innerHTML = '';
        button.appendChild(hoverPin);
      } else if (!wrapper.isSelected) {
        button.classList.remove('is-hovered');
        wrapper.isHovered = false;
        wrapper.style.zIndex = "0";
        button.innerHTML = '';
        button.appendChild(normalPin);
      }
    });

    document.addEventListener(CardClickEvent.eventTypeName, event => {
      let myTarget = `js-yl-${loc.id}`;
      button.innerHTML = '';
      button.appendChild(normalPin);
      if (event.detail.yextId == myTarget) {
        button.classList.add('is-active');
        button.classList.add('is-selected');
        wrapper.isSelected = true;
        wrapper.style.zIndex = "1";
        const bounds = map.getBounds();
        const preBounds = bounds.toString();
        const afterBounds = bounds.extend(latLng).toString();
        if (preBounds != afterBounds) {
          map.panTo(latLng);
        }
      } else {
        button.classList.remove('is-hovered');
        button.classList.remove('is-selected');
        wrapper.isSelected = false;
        wrapper.isHovered = false;
        wrapper.style.zIndex = "0";
      }
    });

    document.addEventListener(PinHoverEvent.eventTypeName, (event) => {
      if (wrapper.isSelected) { return; }
      const currentlyHovered = event.detail.yextId == `js-yl-${loc.id}` && event.detail.active;
      if (!wrapper.isHovered && currentlyHovered) {
        button.classList.add('is-hovered');
        wrapper.isHovered = true;
        wrapper.style.zIndex = "1";
        button.innerHTML = '';
        button.appendChild(hoverPin);
      } else if (wrapper.isHovered && !currentlyHovered) {
        button.classList.remove('is-hovered');
        wrapper.isHovered = false;
        wrapper.style.zIndex = "0";
        button.innerHTML = '';
        button.appendChild(normalPin);
      }
    });

    let marker = new mapboxgl.Marker(wrapper, {offset: new mapboxgl.Point(-this.pinWidth/2, -this.pinHeight/2)}).setLngLat(latLng);
    return marker;
  }
}
CobaltMap.initClass();

let registerResultHandlers = function() {
  let results = document.getElementsByClassName('js-location-result');
  for (let result of Array.from(results)) {
    result.addEventListener('click', function() {
      const minWidthSearchMapBreakPointQuery = window.matchMedia(`(min-width: ${Yext.Maps.CobaltMap.breakPoint}px)`);
      if (!minWidthSearchMapBreakPointQuery.matches) { return; }
      document.dispatchEvent(new CardClickEvent(this.getAttribute('id')));
    });
    result.addEventListener('mouseover', function() {
      const minWidthSearchMapBreakPointQuery = window.matchMedia(`(min-width: ${Yext.Maps.CobaltMap.breakPoint}px)`);
      if (!minWidthSearchMapBreakPointQuery.matches) { return; }
      document.dispatchEvent(new CardHoverEvent(this.getAttribute('id'), true));
    });
    result.addEventListener('mouseout', function() {
      const minWidthSearchMapBreakPointQuery = window.matchMedia(`(min-width: ${Yext.Maps.CobaltMap.breakPoint}px)`);
      if (!minWidthSearchMapBreakPointQuery.matches) { return; }
      document.dispatchEvent(new CardHoverEvent(this.getAttribute('id'), false));
    });
  }
};

let registerDocumentHandlers = function() {
  document.addEventListener(PinClickEvent.eventTypeName, function(e) {
    let id = e.detail.yextId;
    if (id == null) { return; }
    const minWidthSearchMapBreakPointQuery = window.matchMedia(`(min-width: ${Yext.Maps.CobaltMap.breakPoint}px)`);
    if (minWidthSearchMapBreakPointQuery.matches) {
      document.getElementById(id).classList.add('is-selected');
    }
    let toRemove = document.querySelectorAll(`.js-location-result.is-selected:not(#${id})`);
    for (let toChange of Array.from(toRemove)) {
      toChange.classList.remove('is-selected');
      toChange.classList.remove('is-hovered');
    }

    const isIE11 =!!window.MSInputMethodContext && !!document.documentMode;
    const stickyHeight = isIE11 ? 0 : document.querySelector('.Locator-searchWrapper').offsetHeight;

    const targetEl = document.getElementById(id);

    if (document.querySelector('html').classList.contains('chaz')) {
      function isScrolledIntoView(elem) {
        const offTop = window.scrollY + stickyHeight > $(elem).offset().top;
        const offBottom = $(elem).offset().top + elem.offsetHeight > window.scrollY + window.innerHeight;
        return !(offTop || offBottom);
      }

      if (!isScrolledIntoView(targetEl)) {
        $('html ,body').animate({
          scrollTop: $(targetEl).offset().top - stickyHeight,
        }, {duration: 600, queue: false});
      }
    } else if (document.querySelector('html').classList.contains('ace')) {
      const container = document.querySelector('.Locator-content');
      function isScrolledIntoView(elem) {
        const elBottom = $(elem).position().top + elem.offsetHeight;
        return (elBottom <= container.offsetHeight) && ($(elem).position().top >= stickyHeight);
      }

      if (!isScrolledIntoView(targetEl)) {
        $('.Locator-content').animate({
            scrollTop: container.scrollTop + $(targetEl).offset().top - document.querySelector('header').offsetHeight - stickyHeight,
        }, {duration: 600, queue: false});
      }
    }
  });

  document.addEventListener(CardClickEvent.eventTypeName, function(e) {
    let id = e.detail.yextId;
    if (!id) { return; }
    const targetEl = document.getElementById(id);
    let selector = `.js-location-result.is-selected`;
    let toRemove = document.querySelectorAll(selector);
    for (let toChange of Array.from(toRemove)) {
      toChange.classList.remove('is-selected');
    }
    targetEl.classList.add('is-selected');
  });

  document.addEventListener(CardHoverEvent.eventTypeName, function(e) {
    let id = e.detail.yextId;
    const targetEl = document.getElementById(id);
    if (e.detail.active) {
      targetEl.classList.add('is-hovered');
    }
    let selector = `.js-location-result.is-hovered`;
    if (e.detail.active) {
      selector += `:not(#${id})`;
    }
    let toRemove = document.querySelectorAll(selector);
    for (let toChange of Array.from(toRemove)) {
      toChange.classList.remove('is-hovered');
    }
  });
};


export const MapSetup = () => {
  registerResultHandlers();
  registerDocumentHandlers();
}
